exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-hint{color:rgba(0,0,0,.6);font-size:12px;padding:0 12px}.alt-form{background-color:#f5f8fa;padding:32px;border-radius:6px}.white-bg .v-input__slot{background:#fff!important}", ""]);

// exports
